<ng-container *ngIf="actionList$ | async as actionList">
    <table-custom-action-overflow *ngIf="isOverflowView; else collapsedView" [actionList]="actionList"></table-custom-action-overflow>
    <ng-template #collapsedView>
        <table-custom-action-collapsed [actionList]="actionList"></table-custom-action-collapsed>
    </ng-template>
</ng-container>
